module.exports = __webpack_public_path__ + "static/media/cf.6c629850.png";